module.exports = __webpack_public_path__ + "assets/img/1801.7cba5777.png";